import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ListingPaginationConfig } from '../interfaces/listing.interface';

@Component({
  selector: 'app-listing-pagination',
  templateUrl: './listing-pagination.component.html',
  styleUrls: ['./listing-pagination.component.scss']
})
export class ListingPaginationComponent {
  @Input() config!: ListingPaginationConfig;
  @Input() isLoading: boolean = false;
  
  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  // Expose Math to template
  Math = Math;

  getPageNumbers(): (number | string)[] {
    const pages: (number | string)[] = [];
    const total = this.config.totalPages;
    const current = this.config.currentPage;

    if (total <= 7) {
      // Show all pages if 7 or fewer
      for (let i = 1; i <= total; i++) {
        pages.push(i);
      }
    } else {
      // Always show first page
      pages.push(1);

      if (current <= 4) {
        // Near the beginning
        for (let i = 2; i <= 5; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(total);
      } else if (current >= total - 3) {
        // Near the end
        pages.push('...');
        for (let i = total - 4; i <= total; i++) {
          pages.push(i);
        }
      } else {
        // In the middle
        pages.push('...');
        for (let i = current - 1; i <= current + 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(total);
      }
    }
    
    return pages;
  }

  onPageClick(page: number | string): void {
    if (page === '...' || typeof page !== 'number') {
      return;
    }
    this.pageChange.emit(page);
  }

  onPageSizeChange(size: number): void {
    this.pageSizeChange.emit(size);
  }
}
